import { switcher, toID } from '../utils';
import { ACTIONS } from '../../const';
import R from 'ramda';

let nextCid = 1;
export const markupRecord = data => {
    return {
        cid: `cid_${nextCid++}`,
        resource_uri: null,
        id: null,
        page: null,
        owner: null,
        created: null,
        author: null,
        author_name: null,
        content_id: null,
        content: null,
        selection_text: null,
        section: null,
        slug: null,
        x1: null,
        y1: null,
        x2: null,
        y2: null,
        color: null,
        selections: null,
        note_text: null,
        is_question: false,

        answer_id: null,
        in_response_to: null,
        tags: [],
        type: 'selection',
        position: null,
        ...data,
    };
};

function extractPosition(markup, index) {
    const { position, type } = markup;
    let positions;

    if (position == '' || position == null || type == 'response') {
        positions = [markup.x1, markup.y1, markup.x2, markup.y2];
    } else {
        // # If I add an extra space and comma then all of the fields will
        // # exist even if they're empty.
        const [start, end] = `${position} ,`.split(' ');
        positions = start.split(',').concat(end.split(','));
    }

    const value = parseInt(positions[index], 10);
    if (isNaN(value)) {
        return null;
    }
    return value;
}

function updateOrCreate(state, data, cid) {
    let markup;
    let original;

    if (cid != null) {
        const tmp = R.compose(
            R.find(m => m.cid == cid),
            R.values
        );
        original = markup = tmp(state);
        if (markup == null) {
            throw new Error('Unable to find markup by cid');
        }
    } else if (data.id != null) {
        original = markup = state[data.id];
    }

    if (markup == null) {
        markup = markupRecord();
    }
    markup = {
        ...markup,
        tags: [],
        ...data,
    };

    let { content_id } = markup;
    if (content_id == null) {
        content_id = toID(markup.content);
    }

    if (content_id == null) {
        throw new Error('Unable to find content');
    }

    if (typeof markup.tags === 'string') {
        const tagsFromServer = R.compose(
            R.uniq,
            R.map(R.trim),
            R.split(',')
        );

        // Tags come down as a comma separated string, but need to get converted
        // to an Immutable Set that doesn't contain an empty string
        markup.tags = tagsFromServer(markup.tags);
    }
    // Remove empty strings
    markup.tags = R.filter(t => t != '', markup.tags);

    markup = {
        ...markup,
        content: `/api/v3/content/${content_id}/`,
        content_id,
        x1: extractPosition(markup, 0),
        y1: extractPosition(markup, 1),
        x2: extractPosition(markup, 2),
        y2: extractPosition(markup, 3),
    };

    // # If the new version has an ID and the old one didn't, remove the old
    // # version from storage.
    if (markup.id != null && original != null && original.id == null) {
        state = R.dissoc(String(original.cid), state);
    }
    const index = markup.id == null ? markup.cid : markup.id;

    return {
        ...state,
        [index]: markup,
    };
}

function fromServer(state, data, cid) {
    return updateOrCreate(
        state,
        {
            ...data,
            content_id: toID(data.content),
        },
        cid
    );
}

export default switcher(
    {},
    {
        [ACTIONS.UPDATE_SELECTIONS](state, action) {
            const { cid, selections } = action.payload;

            const updateSelection = markup => {
                if (markup.cid == cid) {
                    return {
                        ...markup,
                        selections,
                    };
                }
                return markup;
            };

            return R.map(updateSelection, state);
        },
        [ACTIONS.NEW_MARKUP](state, action) {
            const { author, author_name } = action.meta;

            return updateOrCreate(state, {
                ...action.payload,
                // # We shouldn't send these to the server because something there
                // # creates the correct values, but they need to be filled in
                // # for the all notes view.
                author,
                author_name,
                created: new Date().toISOString(),
            });
        },
        [ACTIONS.UPDATE_MARKUP](state, action) {
            const { cid, fields } = action.payload;

            return updateOrCreate(state, fields, cid);
        },
        [ACTIONS.SYNC_MARKUP](state, action) {
            const { cid } = action.meta;
            return fromServer(state, action.payload, cid);
        },
        [ACTIONS.SYNC_MARKUP_BUNDLE](state, action) {
            const { bundle } = action;

            return bundle.objects.reduce((tmpState, data) => {
                return updateOrCreate(tmpState, data);
            }, state);
        },
        [ACTIONS.DELETE_MARKUP](state, action) {
            const cid = action.payload;
            const excludeByCid = R.complement(R.propEq('cid', cid));

            return R.filter(excludeByCid, state);
            // return state.filter(m => m.cid != cid)
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/markup/markup.js